import formatTableJson from '@/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'deviceCode',
    label: '设备ID'
  },
  {
    filed: 'version',
    label: '固件版本'
  },
  {
    filed: 'productModel',
    label: '固件型号'
  },
  // {
  //   filed: 'hardwareModel',
  //   label: '硬件型号'
  // },
  {
    filed: 'remark',
    label: '其他信息'
  }
])
